import { Navigate } from 'react-router-dom'
import { useMember } from '../../contexts/MemberContext'

interface SectionGuardProps {
  section: string
  children: React.ReactNode
}

export function SectionGuard({ section, children }: SectionGuardProps) {
  const { canAccess, firstAllowedPath, loading } = useMember()
  if (loading) return null
  if (!canAccess(section)) return <Navigate to={firstAllowedPath()} replace />
  return <>{children}</>
}
